var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.893 5.236c-.093-.388-.465-.776-.93-.776L9.52 3.975 7.941.68C7.753.29 7.381 0 7.01 0c-.466 0-.838.29-1.024.679l-1.58 3.296-3.442.485c-.465.097-.744.388-.93.776-.093.388 0 .872.279 1.163L2.825 8.92l-.558 3.684c-.093.485.093.873.465 1.164.372.29.837.29 1.21.097l3.161-1.745 3.162 1.745c.186.097.372.097.558.097.186 0 .466-.097.652-.194.372-.291.558-.679.465-1.164l-.558-3.587 2.51-2.52c.094-.389.187-.777 0-1.261z",
    fill: "#F2B718"
  })));
}
export default SvgRatingM;